import React, { useEffect, useState, useCallback } from 'react';
import { P, font, mono } from '../styles/theme';
import { Card, Spinner } from '../components/Shared';
import { DatKhamService } from '../services/api';

const PAGE_SIZE = 20;

const fmt = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d)) return s;
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()} ` +
    `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};
const fmtDate = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d)) return s;
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

export default function AdminDatKhamPage({ onBack }) {
  const [search, setSearch] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [delTarget, setDelTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const load = useCallback(async (nextPage = 1) => {
    setLoading(true); setError('');
    try {
      const data = await DatKhamService.list({ search, from, to, page: nextPage, pageSize: PAGE_SIZE });
      setItems(data.items || []);
      setTotal(data.total || 0);
      setPage(nextPage);
    } catch (err) {
      setError(err.response?.data?.message || 'Không thể tải danh sách đặt khám');
    } finally {
      setLoading(false);
    }
  }, [search, from, to]);

  useEffect(() => { load(1); /* initial */ }, []); // eslint-disable-line

  const handleSearch = (e) => { e.preventDefault(); load(1); };

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  const go = (p) => { if (p >= 1 && p <= totalPages) load(p); };

  const confirmDelete = async () => {
    if (!delTarget) return;
    setDeleting(true);
    try {
      await DatKhamService.remove(delTarget.idDatKham);
      setDelTarget(null);
      const nextPage = items.length === 1 && page > 1 ? page - 1 : page;
      await load(nextPage);
    } catch (err) {
      setError(err.response?.data?.message || 'Xóa thất bại');
    } finally {
      setDeleting(false);
    }
  };

  const th = { textAlign: 'left', padding: '10px 12px', fontSize: 12, fontWeight: 700, color: P.textDim, whiteSpace: 'nowrap', borderBottom: '2px solid ' + P.border };
  const td = { padding: '10px 12px', fontSize: 13, color: P.text, borderBottom: '1px solid ' + P.border + '66', verticalAlign: 'top' };
  const inputStyle = {
    padding: '9px 12px', background: P.inputBg, border: '1px solid ' + P.border,
    borderRadius: 8, color: P.text, fontSize: 13, fontFamily: font, outline: 'none',
  };

  return (
    <div style={{ minHeight: '100vh', background: P.bg, fontFamily: font, color: P.text }}>
      <header style={{
        position: 'sticky', top: 0, zIndex: 10, background: P.headerBg,
        borderBottom: '2px solid ' + P.primaryDark, padding: '12px 24px',
        display: 'flex', alignItems: 'center', gap: 12,
      }}>
        <button onClick={onBack} title="Quay lại" style={{
          width: 36, height: 36, borderRadius: 8,
          background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)',
          color: P.headerText, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div style={{ fontSize: 15, fontWeight: 700, color: P.headerText }}>Quản trị đặt khám</div>
      </header>

      <div style={{ maxWidth: 1180, margin: '0 auto', padding: '20px 18px 60px' }}>
        {/* Filters */}
        <Card style={{ padding: '16px 18px', marginBottom: 18 }}>
          <form onSubmit={handleSearch} style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end' }}>
            <div style={{ flex: '1 1 240px' }}>
              <label style={{ display: 'block', fontSize: 12, color: P.textDim, marginBottom: 5, fontWeight: 600 }}>Tìm kiếm</label>
              <input style={{ ...inputStyle, width: '100%', boxSizing: 'border-box' }} value={search}
                onChange={(e) => setSearch(e.target.value)} placeholder="Tên, SĐT hoặc CCCD" />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: P.textDim, marginBottom: 5, fontWeight: 600 }}>Từ ngày</label>
              <input style={inputStyle} type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: P.textDim, marginBottom: 5, fontWeight: 600 }}>Đến ngày</label>
              <input style={inputStyle} type="date" value={to} onChange={(e) => setTo(e.target.value)} />
            </div>
            <button type="submit" style={{
              padding: '9px 22px', borderRadius: 8, border: 'none', cursor: 'pointer',
              background: `linear-gradient(135deg, ${P.primary}, ${P.primaryDark})`,
              color: P.white, fontSize: 13, fontWeight: 700, fontFamily: font,
            }}>Lọc</button>
            <button type="button" onClick={() => { setSearch(''); setFrom(''); setTo(''); setTimeout(() => load(1), 0); }} style={{
              padding: '9px 18px', borderRadius: 8, cursor: 'pointer',
              background: P.white, border: '1px solid ' + P.border, color: P.textDim, fontSize: 13, fontWeight: 600, fontFamily: font,
            }}>Xóa lọc</button>
          </form>
        </Card>

        {error && (
          <div style={{ padding: '11px 14px', borderRadius: 8, background: '#fde8e8', border: '1px solid #f5c6cb', color: P.danger, fontSize: 13, marginBottom: 16 }}>{error}</div>
        )}

        <Card style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '14px 18px', borderBottom: '1px solid ' + P.border, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>Danh sách phiếu đặt khám</span>
            <span style={{ fontSize: 13, color: P.textMuted }}>Tổng: <strong style={{ color: P.text }}>{total}</strong></span>
          </div>

          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 50 }}><Spinner /></div>
          ) : items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 50, color: P.textMuted, fontSize: 14 }}>Không có phiếu đặt khám nào.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={th}>#</th>
                    <th style={th}>Bệnh nhân</th>
                    <th style={th}>Giới tính</th>
                    <th style={th}>Ngày sinh</th>
                    <th style={th}>SĐT</th>
                    <th style={th}>CCCD</th>
                    <th style={th}>Ngày đặt khám</th>
                    <th style={th}>Bác sỹ</th>
                    <th style={th}>Dịch vụ</th>
                    <th style={th}>Mã lượt khám</th>
                    <th style={th}></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((it) => (
                    <tr key={it.idDatKham}>
                      <td style={{ ...td, fontFamily: mono, color: P.textMuted }}>{it.idDatKham}</td>
                      <td style={{ ...td, fontWeight: 600 }}>
                        {it.tenBenhNhan}
                        {it.diaChi ? <div style={{ fontSize: 11, color: P.textMuted, fontWeight: 400, marginTop: 2 }}>{it.diaChi}</div> : null}
                      </td>
                      <td style={td}>{it.gioiTinhText || '—'}</td>
                      <td style={td}>{fmtDate(it.ngaySinh)}</td>
                      <td style={{ ...td, fontFamily: mono }}>{it.dienThoai}</td>
                      <td style={{ ...td, fontFamily: mono }}>{it.soCccd || '—'}</td>
                      <td style={td}>{fmt(it.ngayDatKham)}</td>
                      <td style={td}>{it.tenBacSy || '—'}</td>
                      <td style={td}>{it.tenDichVu || '—'}</td>
                      <td style={td}>
                        {it.maLuotKham
                          ? <span style={{ fontFamily: mono, color: P.success, fontSize: 12 }}>{it.maLuotKham}</span>
                          : <span style={{ fontSize: 11, color: P.warning, background: '#fef3e2', padding: '2px 8px', borderRadius: 12 }}>Chưa tiếp đón</span>}
                      </td>
                      <td style={td}>
                        <button onClick={() => setDelTarget(it)} title="Xóa" style={{
                          width: 30, height: 30, borderRadius: 7, cursor: 'pointer',
                          background: '#fde8e8', border: '1px solid #f5c6cb', color: P.danger,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          {!loading && totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, padding: '14px 0' }}>
              <button onClick={() => go(page - 1)} disabled={page <= 1} style={pgBtn(page <= 1)}>Trước</button>
              <span style={{ fontSize: 13, color: P.textDim }}>Trang {page}/{totalPages}</span>
              <button onClick={() => go(page + 1)} disabled={page >= totalPages} style={pgBtn(page >= totalPages)}>Sau</button>
            </div>
          )}
        </Card>
      </div>

      {/* Delete confirm modal */}
      {delTarget && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 50,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
        }} onClick={() => !deleting && setDelTarget(null)}>
          <Card style={{ padding: '24px 26px', maxWidth: 420, width: '100%' }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 10px', fontSize: 18, color: P.text }}>Xác nhận xóa</h3>
            <p style={{ margin: '0 0 22px', fontSize: 14, color: P.textDim, lineHeight: 1.6 }}>
              Xóa phiếu đặt khám của <strong>{delTarget.tenBenhNhan}</strong> (SĐT {delTarget.dienThoai})? Hành động này không thể hoàn tác.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button onClick={() => setDelTarget(null)} disabled={deleting} style={{
                padding: '9px 18px', borderRadius: 8, cursor: 'pointer',
                background: P.white, border: '1px solid ' + P.border, color: P.textDim, fontSize: 14, fontWeight: 600, fontFamily: font,
              }}>Hủy</button>
              <button onClick={confirmDelete} disabled={deleting} style={{
                padding: '9px 20px', borderRadius: 8, border: 'none', cursor: deleting ? 'wait' : 'pointer',
                background: P.danger, color: P.white, fontSize: 14, fontWeight: 700, fontFamily: font,
                display: 'flex', alignItems: 'center', gap: 8,
              }}>
                {deleting && <Spinner size={16} color={P.white} />}
                {deleting ? 'Đang xóa...' : 'Xóa'}
              </button>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

const pgBtn = (disabled) => ({
  padding: '7px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, fontFamily: font,
  background: '#ffffff', border: '1px solid ' + P.border,
  color: disabled ? P.textMuted : P.primary, cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.5 : 1,
});
